import { Icon, Typography } from '@/modules/perseo-billing/ui/react/src';

import type { TInfoBlock } from '.';

const InfoBlock = ({ icon, title, value }: TInfoBlock) => (
  <div
    tabIndex={0}
    className="co-flex co-rounded-4px co-p-8px co-gap-8px co-bg-pds-neutral-100 lg:co-w-1/4"
  >
    <Icon
      className={'co-fill-current co-text-pds-primary-500 co-shrink-0'}
      icon={icon}
      width={24}
      height={24}
    />
    <div className="co-flex co-flex-col co-gap-4px co-overflow-hidden">
      <Typography
        className="co-whitespace-nowrap"
        weight="semibold"
        color="pds-neutral-700"
      >
        {' '}
        {title}{' '}
      </Typography>
      <p className="co-text-body1 co-text-pds-neutral-700 co-max-w-[250px] co-break-words co-leading-16px co-text-ellipsis">
        {' '}
        {value}{' '}
      </p>
    </div>
  </div>
);

export default InfoBlock;
